/**
 * Aircraft utility functions for temporal parking
 */

import { ParkingRequest } from "../types";

/**
 * Get display name for an aircraft using a consistent fallback hierarchy
 *
 * Priority:
 * 1. Tail number (most specific identifier)
 * 2. Aircraft model (if tail number not available)
 * 3. Request ID (fallback for unnamed aircraft)
 *
 * @param aircraft - The parking request containing aircraft information
 * @returns Display-friendly aircraft identifier
 *
 * @example
 * getAircraftDisplayName({ tailNumber: "N12345", ... }) // "N12345"
 * getAircraftDisplayName({ aircraft: { model: "Citation X" }, ... }) // "Citation X"
 * getAircraftDisplayName({ id: "req-123", ... }) // "req-123"
 */
export function getAircraftDisplayName(aircraft: ParkingRequest): string {
  return aircraft.tail_number || aircraft.aircraft?.model || aircraft.id;
}
